import React from 'react';
import BookingForm from '../BookingForm/BookingForm';

export default function RequestRepair({ isModal, onClose, onSubmit }) {
  return (
    <div style={{ background: '#fff', borderRadius: '16px', maxWidth: '600px', width: '90%', maxHeight: '90vh', overflowY: 'auto', padding: '1rem', position: 'relative' }}>
      <button 
        onClick={onClose} 
        style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', zIndex: 10 }}
      >
        ✕
      </button>
      <BookingForm />
    </div>
  );
}
